import React from 'react';

export default function IconDisclose({ ...props }) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <title>Disclose arrow</title>
      <path
        d="M1 1L5 5L9 1"
        stroke="#4B4B4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
